import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
	ModuleSAE,
	Parcours
} from 'src/app/shared/models/services-aide-emploi/parcours';

@Component({
	selector: 'app-module-detail-modal',
	templateUrl: './module-detail-modal.component.html',
	styleUrl: './module-detail-modal.component.scss'
})
export class ModuleDetailModalComponent {
	module: ModuleSAE;
	parcours: Parcours;

	constructor(public bsModalRef: BsModalRef, private router: Router) {}

	formatMinutes(minutes: number): string {
		if (minutes == null) return '';
		const hours = Math.floor(minutes / 60);
		const mins = minutes % 60;
		return `${hours.toString().padStart(2, '0')}:${mins
			.toString()
			.padStart(2, '0')}`;
	}

	navigateToMission(missionId: number): void {
		this.bsModalRef.hide(); // ferme la modale
		this.router.navigate(['/gestion/formations', missionId]);
	}
}
